import { Home, ShoppingBag, User, Utensils, Stethoscope } from "lucide-react";

const UtensilsIcon = () => <Utensils size={20} />;
const ShoppingBagIcon = () => <ShoppingBag size={20} />;
const HealthcareIcon = () => <Stethoscope size={20} />;
const UserIcon = () => <User size={20} />;

export const tabs = [
  {
    title: "Restaurants",
    type: "restaurant",
    keyword: "indian",
    icon: <UtensilsIcon />,
  },
  {
    title: "Groceries",
    type: "supermarket|grocery_or_supermarket|food|store",
    keyword: "indian",
    icon: <ShoppingBagIcon />,
  },
  {
    title: "Professionals",
    type: "doctor",
    keyword: "doctors+near+me+that+speak-desi+language",
    icon: <HealthcareIcon />,
    subCategory: [
      {
        title: "Doctor",
        type: "doctor",
        keyword: "doctors+near+me+that+speak-desi+language",
      },
      {
        title: "Attorney",
        type: "attorney",
        keyword: "Attorneys+near+me+that+speak-desi+language",
      },
      {
        title: "Tax Consultant",
        type: "tax_consultant",
        keyword: "Tax Consultants+near+me+that+speak-desi+language",
      },
      {
        title: "Realtor",
        type: "realtor",
        keyword: "Realtors+near+me+that+speak-desi+language",
      },
      {
        title: "Mechanic",
        type: "mechanic",
        keyword: "Mechanics+near+me+that+speak-desi+language",
      },
      {
        title: "Purohit",
        type: "purohit",
        keyword: "purohit+hindu+priest+pandit+religious+ceremony",
      },
    ],
  },
  {
    title: "Small Businesses",
    type: "florist|convenience_store|liquor_store|pet_store|clothing_store|jewelry_store|book_store|hardware_store|pharmacy|beauty_salon|hair_care|laundry|shoe_store",
    keyword: "",
    icon: <UserIcon />,
  },
];
